import React, { ReactNode } from 'react';
import { TextList, TextListItem, TextListVariant } from '@naf-simba/elements-textlist';
import { BlockContentContext } from '../BlockContent.utils';
import { ArticleWrapper } from './ArticleListWrapper';

interface ListComponentProps {
  variant: 'bullet' | 'number' | 'check' | 'close';
  children?: ReactNode;
  context?: BlockContentContext;
}

// The new TextList has no 'close' marker; it falls back to dotted.
const simbaVariants: Record<ListComponentProps['variant'], TextListVariant> = {
  bullet: 'dotted',
  number: 'numbered',
  check: 'checked',
  close: 'dotted',
};

export const ListComponent = ({ variant, children, context }: ListComponentProps) => {
  const isArticle = context === BlockContentContext.Article;
  return (
    <ArticleWrapper isArticle={isArticle} styleName="list">
      <TextList variant={simbaVariants[variant]}>
        {Array.isArray(children)
          ? children.map((c: any) => <TextListItem key={c.key}>{c.props.children}</TextListItem>)
          : null}
      </TextList>
    </ArticleWrapper>
  );
};
